module.exports = "/virtual-football-league/img/amblems/right/logos/TottenhamHotspur.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/TottenhamHotspur.png
// module id = 2232
// module chunks = 4